export const DOC_TYPE_COMMISSION_AGREEMENT = 'CA';
export const DOC_TYPE_OTHER = 'OTH';
export const COMMISSION_ATTACHMENT_KEY = 'commission_agreement_attachments';
export const FIELD_KEY_HAS_COMMISSION_AGREEMENT = 'has_commission_agreement';
export const FIELD_KEY_COMMISSION_AGREEMENT = 'commission_agreement';
export const BOUNDS_CACHE_KEY = 'voucher_verify_bounds';
export const FIELD_KEY_IS_FULLY_EXECUTED_LEASE = 'is_fully_executed_lease';
export const FIELD_KEY_FULLY_EXECUTED_LEASE = 'fully_executed_lease';
export const LEGACY_COMMISSION_ATTACHMENT_KEY = 'has_commission_agreement_attachments';
export const EMPTY_OUTLIER_RANGES = {};

// Maps /api/broker-verification/bounds field keys to internal field names.
export const BOUNDS_KEY_MAP = {
  base_rent: 'base_rent',
  free_rent: 'free_rent',
  tenant_improvement_allowance: 'tenant_improvement_allowance_amount_per_sqft',
  lease_escalation_amount: 'rent_escalation_dollar',
  lease_escalation_percent: 'rent_escalation_percent',
  operating_expenses: 'operating_expenses_amount_per_sqft',
  term: 'lease_term_months',
  sign_date: 'date_lease_execution',
  start_date: 'date_lease_from',
  expiration_date: 'lease_expiration_date',
  occupancy_date: 'date_lease_occupancy',
};

// Display labels for a minDateReference.attributeKey (a bounds API key, e.g. 'start_date') --
// matches PropertyReview.js's buildLeaseDateFieldValues wording exactly.
export const DATE_REFERENCE_LABELS = {
  sign_date: 'Lease Execution Date',
  start_date: 'Lease Start Date',
  expiration_date: 'Lease Expiration Date',
  occupancy_date: 'Lease Occupancy Date',
};
